<template>
    <div v-if="stats" class="chat-stat">
        <div class="stats flex-row">
            <div class="stat flex-fill" :key="stat.key" v-for="stat in stats">
                <div class="icon"><img :src="stat.img" />{{ `CHAT_STAT_${stat.key}`.toUpperCase() | translate }}</div>
                <div class="value flex-row">
                    <div class="flex-wrap" v-html="stat.value" />
                    <div v-if="stat.value !== '-'" class="color flex-wrap" :class="stat.color" />
                </div>
            </div>
            <div class="desc flex-wrap">
                <i class="material-icons f-15" :class="{ 'c-primary': showDesc }" @click="onClickSeeDesc">info</i>
            </div>
        </div>

        <transition name="slide-down">
            <div v-show="showDesc" class="chat-stat-desc">
                <div class="grid-col">
                    <div class="item flex-row" :key="key.key" v-for="key in descKeys">
                        <div class="key flex-wrap" v-html="$translate(`CHAT_STAT_${key.key.toUpperCase()}`)" />
                        <div class="value flex-fill" v-html="$translate(`CHAT_STAT_${key.key.toUpperCase()}_DESC`)" />
                    </div>
                </div>
                <div class="hr" />
                <div class="desc" v-html="$translate('CHAT_STAT_DESC')" />
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'user',
    computed: {
        descKeys() {
            const k = this.keys
            return [k[0], k[3], k[1], k[4], k[2], k[5]]
        },
        keys() {
            return [
                { key: 'match' },
                { key: 'photo' },
                { key: 'agent' },
                { key: 'refund' },
                { key: 'pay' },
                { key: 'ticket_count' },
            ]
        },
        stats() {
            const stats = (this.$store.getters.chat || {}).$$stat
            if (!stats) return

            return this.keys.map(o => {
                const col = `${o.key}_info`

                return {
                    key: o.key,
                    value: stats[col].value,
                    color: stats[col].color,
                    img: require(`@/assets/images/chat-stat/${o.key}.svg`),
                }
            })
        },
    },
    data: () => ({
        showDesc: false,
    }),
    methods: {
        onClickSeeDesc() {
            this.showDesc = !this.showDesc
        },
    },
}
</script>
